// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"src-components-CopyToClipboard---wrapper---3ISQQ","icon":"src-components-CopyToClipboard---icon---1SXK9"};